import React from "react";
//import twitterimg from "../../styles/img/twitter-logo.png";
//import { useSelector } from "react-redux";

/**
 *
 * @returns {JSX.Element}
 * @component
 */
const TopHeader = () => {
  //const { homeData } = useSelector((state) => state.pageContents);

  return (
    <>
      <div className="top-header-area">
        <div className="container header-container">
          <div className="row align-items-center">
            <div className="col-lg-6 col-md-6 col-sm-12 ">
              <ul className="header-content-left header-conts-left">
                <li className="top-heading-left">
                  Society for Maternal-Fetal Anesthesia
                </li>
              </ul>
            </div>
            {/* Search bar */}
            {/* <div className="col-md-5  col-md-5 col-sm-10">
              <div className="search-sec">
                <form
                  role="search"
                  method="get"
                  className="search-form form"
                  action=""
                >
                  <label>
                    <span className="screen-reader-text">Search for...</span>
                    <input
                      type="search"
                      className="search-field ss-search"
                      placeholder="Search Here"
                      name=""
                      title=""
                    />
                  </label>
                  <input
                    type="submit"
                    className="search-submits button-srch"
                    value="Search"
                  />
                </form>
              </div>
            </div> */}

            <div className="col-lg-1 col-md-1 col-sm-2">
              <ul className="header-content-right">
                {/* <li>
                  <a href="https://www.facebook.com/" target="_blank">

                    <img src={facebookimg} />
                  </a>
                </li> */}
                {/* {homeData?.widgetdata && (
                  <li>
                    <a
                      href={homeData.widgetdata.footer_twitter_link}
                      target="_blank"
                      rel="noreferrer"
                    >
                      <img src={twitterimg} alt="[]" />
                    </a>
                  </li>
                )} */}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default TopHeader;
